import { isNewEvidence } from '@utils/survey/evidence';
import { HandleNewEvidenceFn, EvidenceFile } from '@g17eco/types/file';
import { AiProcessingValue } from '@g17eco/types/ai';
import { Toggle } from '@g17eco/molecules/toggle';

interface AIProcessingToggleProps {
  file: EvidenceFile;
  handleAiProcessing: HandleNewEvidenceFn | undefined;
  disabled?: boolean;
}

export const AIProcessingToggle = (props: AIProcessingToggleProps) => {
  const { file, handleAiProcessing, disabled = false } = props;

  if (!isNewEvidence(file) || !handleAiProcessing) {
    return null;
  }

  // Switch is only enabled if saveToLibrary is true
  const isSavedToLibrary = file.saveToLibrary ?? false;

  // Treat undefined as 'include' (opt-in behavior)
  const isAIProcessingEnabled = file.aiProcessing === AiProcessingValue.Include || file.aiProcessing === undefined;

  return (
    <div className='d-flex gap-1 mt-2 align-items-center' data-testid='ai-processing-toggle'>
      <Toggle
        checked={isAIProcessingEnabled && isSavedToLibrary}
        disabled={disabled || !isSavedToLibrary}
        onChange={() => handleAiProcessing(file)}
        testId='ai-processing-switch'
      />
      <span className={!isSavedToLibrary ? 'text-muted' : ''}>AI processing</span>
    </div>
  );
};
